import { useFormikContext } from 'formik';
import React, { useContext, useEffect, useRef } from 'react';
import Context from '../context/form-context';
import { buscarRegrasComuns } from '../regrasComuns';
import { buscarRegrasPorPlano } from '../regrasPorPlano';

export const MsgsValicaoesPlano = () => {
    const { state, setState } = useContext(Context);

    const {
        plano,
        idadeAssociado,
        dependentes,
        categorias,
        arrayMsgsValidacoesPlano,
        editar,
        objComparadorEdicao,
        codigoIbge,
        troca,
        subGrupoSelecionadoUpSell
    } = state;
    const { values, isValid } = useFormikContext();
    const lastDependencies = useRef({ dependentes: null });

    if (dependentes.length && (!lastDependencies.current.dependentes || lastDependencies.current.dependentes !== dependentes)) {
        lastDependencies.current.dependentes = dependentes;
    }

    useEffect(() => {
        (async () => {
            let msgsErro = [];

            if (!editar) {
                msgsErro = await buscarRegrasPorPlano(
                    plano.trim(),
                    dependentes,
                    values.Parentesco,
                    categorias,
                    values,
                    false,
                    null,
                    isValid,
                    idadeAssociado,
                    codigoIbge,
                    troca,
                    subGrupoSelecionadoUpSell

                );
                msgsErro = await buscarRegrasComuns(values, msgsErro, dependentes, plano.trim());

                if (msgsErro?.length && msgsErro.some(erro => erro !== '')) {
                    setState({
                        ...state,
                        arrayMsgsValidacoesPlano: msgsErro,
                        temErroPorPlano: true
                    });
                } else {
                    setState({
                        ...state,
                        arrayMsgsValidacoesPlano: [''],
                        temErroPorPlano: false
                    });
                }
            }

            if (editar && values !== objComparadorEdicao) {
                msgsErro = await buscarRegrasPorPlano(
                    plano.trim(),
                    dependentes,
                    values.Parentesco,
                    categorias,
                    values,
                    editar,
                    objComparadorEdicao, idadeAssociado,
                    idadeAssociado,
                    codigoIbge,
                    troca,
                    subGrupoSelecionadoUpSell
                );
                msgsErro = await buscarRegrasComuns(values, msgsErro, dependentes, plano.trim());

                if (msgsErro?.length && msgsErro.some(erro => erro !== '')) {
                    setState({
                        ...state,
                        arrayMsgsValidacoesPlano: msgsErro,
                        temErroPorPlano: true
                    });
                } else {
                    setState({
                        ...state,
                        arrayMsgsValidacoesPlano: [],
                        temErroPorPlano: false
                    });
                }
            }
        })();
    }, [values, lastDependencies.current.dependentes]);

    return (
        <ul style={{ color: 'red' }}>
            {arrayMsgsValidacoesPlano.map((erro, idx) => <li key={idx}>{erro}</li>)}
        </ul>
    );
};
